import { Component, ElementRef, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import Chart from 'chart.js/auto';

import axios from "src/app/Service/axios";

import { Location } from '@angular/common';

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  Draw,

  defaults as defaultInteractions,

} from 'ol/interaction';


import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";

import { MapService } from "src/app/Service/map.service";

import { DeviceDetectorService } from "ngx-device-detector";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import "ol/ol.css";

import * as XLSX from 'xlsx';

import zoomPlugin from 'chartjs-plugin-zoom';

import { getRelativePosition } from 'chart.js/helpers';

import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from "@angular/forms";

import { DataService } from "src/app/Service/data.service";

import { Observable, map, startWith } from "rxjs";

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { animate, state, style, transition, trigger } from '@angular/animations';

import { GurdServiceService } from "src/app/Service/gurd-service.service";

import * as L from 'leaflet';

declare let $: any;

@Component({

  selector: 'app-service-determination',

  templateUrl: './service-determination.component.html',

  styleUrls: ['./service-determination.component.css']

})

export class ServiceDeterminationComponent implements OnInit {

  list_Schools: any = [];

  filteredSchools = [];

  filteredDrivers = [];

  lstiMobileDomain: any = [];

  list_Drivers: any = [];

  list_Std4Drivers: any = [];

  searchT_School = '';

  searchD_School = '';

  source: any;

  vector: any;

  layers: any = [];

  map: any;

  draw: any;

  polygonEvent: any;

  tiStatus: string = '2';

  tiGender: string = '0';

  studentData: any;

  strUnitID!: string;

  bDetermination: boolean = false;

  bDriverStd: boolean = false;

  isLoading: boolean = false;

  iResult: number = 0;

  driverModel: object = {};

  mdl_Cluster: FormGroup = this.fb.group({

    lslMobileDomain: new FormControl('', Validators.required),

    tiStatus: new FormControl(''),

    tiGender: new FormControl(''),

    tiPassengers: new FormControl('4', Validators.required),

    fMaxDistanceInKm: new FormControl('', Validators.required),

  })

  constructor(

    private router: Router,

    private FormBuilder: FormBuilder,

    private Notification: NotificationService,

    private mapService: MapService,

    private gurdService: GurdServiceService,

    private fb: FormBuilder

  ) { }

  ngOnInit(): void {

    this.getSchools();

    this.showMap();

    this.getDrivers()

    // setTimeout(() => {

    //   this.vector.getSource().on('addfeature', (e: any) => {

    //     this.polygonEvent = e.feature;

    //     this.source.removeFeature(e.feature);

    //     this.map.removeInteraction(this.draw);

    //     this.savePolygon();

    //   });

    // }, 900);

    // setTimeout(() => {

    //   this.vector.getSource().on('addfeature', (e: any) => {

    //     this.polygonEvent = e.feature;

    //     this.source.removeFeature(e.feature);

    //     this.source.removeFeature(this.polygonEvent);

    //     this.savePolygon();

    //   });

    //   const value = 'Polygon';

    //   this.draw = new Draw({

    //     source: this.source,

    //     type: value,

    //   });

    //   this.map.addInteraction(this.draw);

    // }, 700);

  }

  filterSchool() {

    this.filteredSchools = this.list_Schools.filter((item: any) => item.strComment.includes(this.searchT_School));

  }

  filterDriver() {

    this.filteredDrivers = this.list_Drivers.filter((item: any) => item.strFullName.includes(this.searchD_School));

  }

  setCheckBox(value: boolean, item: any) {

    if (value === true) this.lstiMobileDomain.push(item.iMobileDomain);

    else {

      this.lstiMobileDomain.find((value: any) => {

        if (value === item.iMobileDomain) {

          const index = this.lstiMobileDomain.indexOf(item.iMobileDomain);

          if (index !== -1) this.lstiMobileDomain.splice(index, 1);

        }

      })

    }

  }

  isSelected(item: any): boolean {

    return this.lstiMobileDomain.indexOf(item) !== -1;

  }

  goBack() {

    this.router.navigate(['/'])

  }

  showMap() {

    setTimeout(() => {

      if (this.map) this.map.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      // نقشه ترافیک

      // this.layers = [

      // new TileLayer({

      //   source: new XYZ({

      //     url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoicm9kcmlnb2thbWFkYSIsImEiOiJjbGZ5NTVhenAwanBzM3Fta3Y3b29temE5In0.PkdHrkHBrx9RALYhyLMRxA',

      //   }),

      // }),

      // new TileLayer({

      //   source: new XYZ({

      //     url: 'https://api.mapbox.com/styles/v1/mapbox/traffic-day-v2/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoicm9kcmlnb2thbWFkYSIsImEiOiJjbGZ5NTVhenAwanBzM3Fta3Y3b29temE5In0.PkdHrkHBrx9RALYhyLMRxA',

      //   }),

      // }),

      // ]

      this.layers.push(new TileLayer({

        source: new OSM({}),

      }), this.vector)

      this.map = new Map({

        layers: this.layers,

        target: 'map',

        view: new View({

          center: olProj.fromLonLat([51.3833554, 35.6770113]),

          zoom: 13,

        }),

      });


      // Adding traffic layer

    }, 500);

  }

  addInteraction() {

    // const value = 'Polygon';

    // this.draw = new Draw({

    //   source: this.source,

    //   type: value,

    // });

    // this.map.addInteraction(this.draw);

  }

  async getSchools() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_User_List`, model)).data.toString())

    this.list_Schools = res;

    this.filteredSchools = res;

  }

  async getDrivers() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_User_Mobile_Search4Asign`, model)).data.toString())

    this.list_Drivers = res;

    this.filteredDrivers = res;


  }

  async selectedDriver(item: any) {

    this.searchD_School = item.strFullName;

    this.strUnitID = item.strUnitID;

    this.filteredDrivers = [];

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: item.strUnitID

    }

    this.driverModel = model;

    let res = JSON.parse((await axios.post(`School_Mobile_Passengers4Asign`, model)).data.toString())

    this.list_Std4Drivers = res

    this.bDriverStd = true;


  }

  async search_result() {

    this.isLoading = true;

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      lslMobileDomain: this.lstiMobileDomain,

      tiStatus: this.tiStatus,

      tiGender: this.tiGender

    }

    let res = JSON.parse((await axios.post(`School_Passenger_Search4AssianDriver`, model)).data.toString());

    this.iResult = res.length;

    this.isLoading = false;

    if (res.iResult == 0) return this.Notification.showError(res.strError);

    else this.showOnMap(res)

  }

  async removeStd4Driver(item: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: item.strUnitID,

      iPassenger: item.iPassenger

    }

    $.confirm({

      title: ` آیا از حذف این دانش آموز اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            let res = JSON.parse((await axios.post(`School_Mobile_Passengers_RemoveDriver`, model)).data.toString());

            if (res.iResult == 0) return this.Notification.showError(res.strError);

            else {

              this.Notification.showSuccess('عمیات با موفقیت انجام شد');

              const index = this.list_Std4Drivers.indexOf(item);

              if (index != -1) this.list_Std4Drivers.splice(index, 1);

              this.getDrivers()

            }

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });


  }

  async determine_StdToDriver() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: this.strUnitID,

      iPassenger: this.studentData.iPassenger

    }

    let res = JSON.parse((await axios.post(`School_Mobile_Passengers_Asign`, model)).data.toString());

    if (res.iResult == 0) return this.Notification.showError(res.strError);

    else {

      let res = JSON.parse((await axios.post(`School_Mobile_Passengers4Asign`, this.driverModel)).data.toString())

      this.list_Std4Drivers = res;

      this.getDrivers()

      this.Notification.showSuccess('عمیات با موفقیت انجام شد');

    }

  }

  showOnMap(data: any) {

    if (this.map) this.map.setTarget(null);

    var layers = [

      new Tile({

        source: new OSM()

      })

    ]

    this.map = new Map({

      target: "map",

      view: new View({

        zoom: 4,

        center: olProj.fromLonLat([51.3833554, 35.6770113])

      }),

      layers: this.layers

    });

    this.clustersLayer(data);


  }

  clustersLayer(data: any) {

    setTimeout(() => {

      this.map.on('click', (e: any) => {

        if (e.dragging) return;

        var el = this.mapService.mapPointerMove(
          this.map.getEventPixel(e.originalEvent),
          this.map
        );

        if (el.featureLayer && el.featureLayer.feature.values_.features.length == 1) this.showDetail(el.featureLayer.feature.values_.features[0].values_.data)

        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.map.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;


    let addFeatures = (nb: any) => {
      var ext = this.map.getView().calculateExtent(this.map.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([
            data[i].fOriginLon,
            data[i].fOrigiLat])

          ),
          id_: data[i].strUnitId,
          data: {
            iPassenger: data[i].iPassenger,
            strName: data[i].strName,
            strFamily: data[i].strFamily,
            strMobile: data[i].strMobile,
            strSex_strSexComment: data[i].strSex_strSexComment,
            strMobileDomain_strComment: data[i].strMobileDomain_strComment,
            fDistance: data[i].fDistance,
            strAddress: data[i].strAddress,
            fOrigiLat: data[i].fOrigiLat,
            fOriginLon: data[i].fOriginLon,
            strAvatar: data[i].strAvatar,
            strNationalCode: data[i].strNationalCode,
            strFullName: data[i].strFullName,
            strPassenger_FullName: data[i].strPassenger_FullName,
          },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();

      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.map.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.map.addInteraction(selectCluster);


  }

  showDetail(item: any) {

    this.bDetermination = false;

    this.bDriverStd = false;


    this.studentData = item;

    $('#detailModal').modal('show');


  }

  backTo() {

    this.bDetermination = false;

    this.bDriverStd = false

    this.searchD_School = '';

    this.filteredDrivers = this.list_Drivers;


  }

  cluster_Modal() {

    if (!this.lstiMobileDomain.length) return this.Notification.showError('حداقل یک مدرسه را انتخاب کنید');

    this.mdl_Cluster.patchValue({

      lslMobileDomain: this.lstiMobileDomain,

      tiStatus: this.tiStatus,

      tiGender: this.tiGender,

      tiPassengers: 4,

      fMaxDistanceInKm: 1,

    })

    $("#Modal_Clustering").modal("show")

  }

  search_Cluster() {

    if (this.mdl_Cluster.invalid) return this.Notification.showError('فرم را با دقت تکمیل کنید');

    if (!this.lstiMobileDomain.length) return this.Notification.showError('حداقل یک مدرسه را انتخاب کنید');

    const queryParams = new URLSearchParams({

      tiStatus: this.mdl_Cluster.get('tiStatus')?.value,

      tiGender: this.mdl_Cluster.get('tiGender')?.value,

      tiPassengers: this.mdl_Cluster.get('tiPassengers')?.value,

      fMaxDistanceInKm: this.mdl_Cluster.get('fMaxDistanceInKm')?.value

    });

    this.lstiMobileDomain.forEach(id => { queryParams.append('mobile', id.toString()) });

    const url = `/school/smart-clustering?${queryParams.toString()}`;

    window.open(url, '_blank');

  }

}